export default {
    isReady: true,
    isReadyDelayTimer: null,
    lifeCycleCounter: 0,
    ajaxCallCounter: 0,

    checkIsReady() {
        console.log('[data-ready] checkIsReady')
        console.log('[data-ready] lifeCycleCounter: ', this.lifeCycleCounter)
        console.log('[data-ready] ajaxCallCounter: ', this.ajaxCallCounter)
        if (this.lifeCycleCounter <= 0 && this.ajaxCallCounter <= 0) {
            this.handleIsReady()
            console.log('[data-ready] handleIsReady')
        } else {
            this.markAs(false)
            console.log('[data-ready] markAs(false)')
        }
    },

    handleIsReady(withoutDelay = false) {
        /**
         * Wir gehen davon aus, dass wenn nach 1,5 Sekunden kein weiterer Ajax Call getriggert wurde,
         * die Anwendung tatsächlich "ready" ist.
         */
        const WAIT_FOR_NO_CHANGES_MS = 1500

        if (this.lifeCycleCounter > 0 || this.ajaxCallCounter > 0) {
            console.log('[data-ready] handleIsReady intercepted')
            this.markAs(false)
            return
        }

        this.lifeCycleCounter = 0
        this.ajaxCallCounter = 0

        if (withoutDelay) {
            console.log('[data-ready] handleIsReady markAs(true)')
            this.markAs(true)
        } else {
            if (this.isReadyDelayTimer !== null) {
                window.clearTimeout(this.isReadyDelayTimer)
            }
            this.isReadyDelayTimer = window.setTimeout(() => {
                this.isReadyDelayTimer = null
                this.handleIsReady(true)
            }, WAIT_FOR_NO_CHANGES_MS)
        }
    },

    markAs(ready) {
        if (ready && !this.isReady) {
            this.isReady = true
            document.body.dataset.ready = 'true'
        } else if (!ready && this.isReady) {
            this.isReady = false
            document.body.dataset.ready = 'false'
        }
    }
}
